import React from 'react'

import { Button, TextInput, toast, Spinner } from '@octane/spark'
import { getMaterialKit } from 'api/dealership'
import config from 'config'
import { useFeatureFlagContext } from 'contexts/FeatureFlagContextProvider'
import { OctaneLogger } from 'integrations/datadog/OctaneLogger'

import useUser from '../../hooks/useUser'
import LoadingStatus from '../../state/enums/LoadingStatus'
import {
    Container,
    WrapperLoader,
    SectionPrequal,
    RowSubtitle,
    Subtitle,
    Title,
    InputTitle,
    RowInput,
    SectionNews,
} from './Home.styled'

const downloadFile = async (dealershipId: number, fileName: string) => {
    const blobData = await getMaterialKit(dealershipId)
    const url = window.URL.createObjectURL(new Blob([blobData]))
    const link = document.createElement('a')

    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
}

export default function Home(): JSX.Element {
    const featureFlags = useFeatureFlagContext()
    const { user, status, isRVDealership } = useUser()
    const flexLink = user?.dealership?.flexLink
    const iframeNewsPath = isRVDealership ? 'rv-dealer-news' : 'news'

    const handleDownloadKit = async () => {
        const pdfName = `Octane Prequal Flex Kit - [${user?.dealership?.name}].pdf`

        downloadFile(user?.dealership?.id as number, pdfName)

        OctaneLogger.info('Prequal Flex kit downloaded')
    }

    const handleCopyLink = () => {
        navigator.clipboard.writeText(flexLink as string)

        toast.show(
            'success',
            {
                duration: 3000,
                position: 'bottom-center',
                title: 'Copied to clipboard!',
                size: 'medium',
                withLine: false,
                withCloseIcon: true,
            },
            <span>{flexLink}</span>,
        )

        OctaneLogger.info('Prequal Flex link copied')
    }

    const showSectionFlexLink =
        flexLink && featureFlags?.showFlexLink && !isRVDealership

    return (
        <Container>
            {status === LoadingStatus.LOADING && !user && (
                <WrapperLoader>
                    <Spinner size={70} />
                </WrapperLoader>
            )}
            {(status === LoadingStatus.LOADED || user) && (
                <>
                    {showSectionFlexLink && (
                        <SectionPrequal data-testid="section-prequal">
                            <div className="column">
                                <Title>
                                    Prequal Flex: Prequalify customers anywhere
                                </Title>
                                <RowSubtitle>
                                    <Subtitle>
                                        QR Codes • Templates & In-store
                                        Materials
                                    </Subtitle>
                                    <Button
                                        size="small"
                                        onClick={handleDownloadKit}
                                    >
                                        Download your kit
                                    </Button>
                                </RowSubtitle>
                            </div>

                            <div className="separator" />

                            <div className="column">
                                <InputTitle>
                                    USE YOUR PREQUAL FLEX LINK
                                </InputTitle>
                                <RowInput>
                                    <TextInput
                                        id="flex-link-input"
                                        type="text"
                                        value={flexLink}
                                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                                        onChange={() => {}}
                                        readOnly
                                    />
                                    <Button onClick={handleCopyLink}>
                                        Copy Your Prequal Flex Link
                                    </Button>
                                </RowInput>
                            </div>
                        </SectionPrequal>
                    )}

                    <SectionNews isRVDealer={isRVDealership}>
                        <iframe
                            title="News"
                            name="news-panel-iframe"
                            className="main-news-panel"
                            sandbox="allow-downloads allow-same-origin allow-scripts allow-popups allow-forms"
                            src={`${config.API_BASE_URL}/${iframeNewsPath}/#`}
                        />
                    </SectionNews>
                </>
            )}
        </Container>
    )
}
